import { useFormContext } from 'react-hook-form';

import { TMobileSignupForm } from './form';
import { useMobileSignupStatus } from './MobileSignupStatusContext';
import { firstUnansweredScreen, TResumeResult } from './resume';
import { useGetContext } from '../../../api/lendingApi/lendingApiQueries';
import { SCREEN_REGISTRY } from '../screens/registry';

export const useMobileSignupResume = (): TResumeResult => {
  const { getValues } = useFormContext<TMobileSignupForm>();
  const { context, contextStatus } = useGetContext();
  const { isSeeded } = useMobileSignupStatus();

  return firstUnansweredScreen(getValues(), SCREEN_REGISTRY, {
    stateKey: context?.state_key,
    isSeeded,
    isContextResolved: contextStatus !== 'pending',
  });
};
